import styled from '@emotion/styled'

import { palette, typography } from 'main/ui/constants'

export const Container = styled.div`
  position: absolute;
  right: 0;
  z-index: 30;
  display: flex;
  justify-content: flex-end;
  margin-right: 1rem;

  > a {
    color: ${palette.almostBlack};
    font-family: ${typography.fontFamily.ui};
    font-size: ${typography.fontSize.tag};
    font-weight: ${typography.fontWeight.regular};
    background-color: ${palette.goldenrod};
    padding: 0 0.5rem 0.25rem 0.5rem;
    border-radius: 0 0 8px 8px;
  }

  > a:visited {
    color: ${palette.almostBlack};
  }
`
